import MultiCurrency from '@/classes/currencies/MultiCurrency'

export default class PublicTransaction {
  constructor ({ id = null, payment_method = null, amount = {}, currency = null } = {}) {
    this.id = id
    this.payment_method = payment_method
    this.amount = new MultiCurrency(amount)
    this.currency = currency
  }
}
